import React, { useRef } from 'react';
import { useNavigate , useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import LoadingButton from '../../../utility/button/LoadingButton';


const ThankYou = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const { successMessage, redirectUrl, label , email } = location.state || {};
  const handleFormSubmit = (e) => {
    email
    ? navigate(redirectUrl, {
        state: {
          email: email,
        },
      })
    : navigate(redirectUrl)
  };

  return (
    <div className="auth-card mx-auto text-center">
      <div className="d-flex justify-content-center mb-4">
        <div style={{
          background: '#f4f5fa',
          borderRadius: 10,
          width: 58,
          height: 58,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}>
          <svg width="38" height="38" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="38" height="38" rx="10" fill="#eceffe" />
            <path d="M28 13v12a1 1 0 01-1 1H11a1 1 0 01-1-1V13" stroke="#363b70" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M28 13l-9 7-9-7" stroke="#363b70" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </div>
      </div>
      <h3 className="fw-bold mb-1">{successMessage}</h3>
      <div className='forgot-sub-heading' style={{fontSize: '1rem', marginBottom: 27 }}>{t('thankYou.subtitle')}</div>
      <LoadingButton
          type="button"
          className="w-100"
          onClick={handleFormSubmit}
        >
        {label || t('thankYou.button')}
      </LoadingButton>
    </div>
  );
};

export default ThankYou;
